import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'lmsDuration'
})
export class DurationPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(scheduledObject: any): any {
    if (!scheduledObject || !scheduledObject.startDate || !scheduledObject.endDate) {
      return '';
    }
    const start = DateTime.fromJSDate(new Date(scheduledObject.startDate));
    const end = DateTime.fromJSDate(new Date(scheduledObject.endDate));
    const diff = end.diff(start, ['months', 'weeks', 'days', 'hours']).toObject();
    const timeUnit = ['months', 'weeks', 'days', 'hours'].find((unit) => diff[unit] > 0);
    const duration = timeUnit ? Math.round(diff[timeUnit]) : 0;
    const timeUnitLabel = this.translate.instant(`calendar.timeUnits.${timeUnit}`);
    return `${duration} ${timeUnitLabel}`;
  }
}
